






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import AsideTools from './AsideTools.vue';

@Component({
  components: { AsideTools },
  computed: {
    ...mapState(['isAsideVisible']),
  },
})
export default class AsideMenu extends Vue {
  @Prop({
    type: Array,
    default: (): any[] => [],
  })
  public menu!: any[];
}
